import  { z } from 'zod';

const DEFAULT_MESSAGE = 'Obrigatório';

export const formSchema = z.object({
  origin_uf: z.string({ message: DEFAULT_MESSAGE }),
  origin_ibge: z.string({ message: DEFAULT_MESSAGE }),
  destination_uf: z.string({ message: DEFAULT_MESSAGE }),
  destination_ibge: z.string({ message: DEFAULT_MESSAGE }),
});

export type FormSchema = z.infer<typeof formSchema>;